import * as service from "../service";
import { store } from "../../store";
import { cloudinaryUploadList } from "../../middleware/uploadImage";
import {
  toEventFormBody,
  type EventDetails,
  type EventFormPayload,
} from "../user/events";
import type { ServiceResponse } from "../types";

/**
 * Create an event for the selected societies. The web port of the RN
 * `UploadEventAPI`.
 * Backend: POST /api/organizer/events/uploadEvent
 */
export const UploadEventAPI = async (
  payload: EventFormPayload,
): Promise<ServiceResponse<EventDetails>> => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call("POST", "api/organizer/events/uploadEvent", {
      user_id: user?.id,
      ...toEventFormBody({
        ...payload,
        imageUrls: await cloudinaryUploadList(payload.imageUrls),
      }),
    });
    return resp;
  } catch (err) {
    console.error(`UploadEventAPI ${err}`);
    return { status: -1 };
  }
};
